import { watch } from "vue";

export default defineNuxtPlugin(() => {
  const { $localStorage } = useNuxtApp();

  // IMPORTANT: keep a dedicated state key for the avatar/photo.
  // `useState('profilo')` is used elsewhere as the full profile object.
  const fotoProfilo = useState("foto_profilo", () => {
    const saved_foto_profilo = $localStorage.getItem("foto_profilo");
    return saved_foto_profilo &&
      String(saved_foto_profilo) !== "null" &&
      String(saved_foto_profilo) !== "undefined"
      ? saved_foto_profilo
      : null;
  });

  watch(
    fotoProfilo,
    (newValue) => {
      if (typeof newValue === "string") {
        $localStorage.setItem("foto_profilo", newValue);
      } else if (newValue && typeof newValue === "object") {
        // Backward compatibility in case someone still sets an object
        if (typeof newValue.foto_profilo === "string") {
          $localStorage.setItem("foto_profilo", newValue.foto_profilo);
        }
      }
    },
    {
      immediate: true,
      deep: true,
    }
  );
});
